<script setup>
import { computed, ref, useEventTracking } from '#imports';

const props = defineProps({
  searchResults: {
    type: Object,
    required: true,
  },
  searchEmpty: {
    type: Boolean,
    required: true,
  },
});

const articles = computed(() =>
  props.searchResults.filter((item) => item._type === 'article')
);

const currentDisplayIndex = ref(5);

const displayedArticles = computed(() =>
  articles.value.slice(0, currentDisplayIndex.value)
);

const hasMoreData = computed(
  () => currentDisplayIndex.value < articles.value.length
);

const loadMore = () => {
  currentDisplayIndex.value += 5;
};
</script>

<template>
  <div class="search-results">
    <div class="search-results__container">
      <div
        v-if="articles.length > 0 && !searchEmpty"
        class="search-results__section"
      >
        <ul class="search-results__list">
          <li v-for="resultItem in displayedArticles" :key="resultItem._id">
            <a
              v-if="resultItem.isArticleExternalSourceType"
              :href="resultItem.externalSource"
              target="_blank"
              @click="
                useEventTracking('click', 'Go to article from search result')
              "
            >
              <ArticleItem :article="resultItem" />
            </a>
            <NuxtLink
              v-else
              :to="{
                name: 'articles-slug',
                params: {
                  slug: resultItem.slug.current,
                },
              }"
            >
              <ArticleItem :article="resultItem" />
            </NuxtLink>
          </li>
        </ul>
        <div v-show="hasMoreData" class="search-results__more-button">
          <MoreContentButton @click="loadMore" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.search-results {
  &__more-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
  }

  &__title {
    margin-bottom: 24px;
  }

  &__subtitle {
    margin-bottom: 16px;
  }

  &__section {
    margin-bottom: 48px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__empty {
    text-align: center;
    margin-top: 48px;
    margin-bottom: 48px;

    @media (max-width: 425px) {
      h2 {
        font-size: 18px;
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
  }
}
</style>
